// Actions for Master Time Frame Interval

import {
  GET_MASTER_TIME_FRAME_INTERVAL_LIST,
  GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS,
  GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE,
} from "./actionType";

// Get Master Time Frame Interval List
export const getMasterTimeFrameIntervalList = () => ({
  type: GET_MASTER_TIME_FRAME_INTERVAL_LIST,
});

export const getMasterTimeFrameIntervalListSuccess = (data) => ({
  type: GET_MASTER_TIME_FRAME_INTERVAL_LIST_SUCCESS,
  payload: data,
});

export const getMasterTimeFrameIntervalListFailure = (error) => ({
  type: GET_MASTER_TIME_FRAME_INTERVAL_LIST_FAILURE,
  payload: error,
});
